 
  <mat-form-field style="width: 100%">
    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
  </mat-form-field>
 
<div mat-dialog-content>



  <mat-table #table [dataSource]="dataSource" class="mat-elevation-z8" style=" height: 600px;
 overflow: auto;">




    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null;showSeelcted()"
          [checked]="selection.isSelected(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="designation">
      <th mat-header-cell *matHeaderCellDef style="width: 500px">Designation </th>
      <td mat-cell *matCellDef="let element"> {{element.designation}} </td>
    </ng-container>

    <ng-container matColumnDef="prixDzd">
      <th mat-header-cell *matHeaderCellDef style="width: 100px">Prix Dinars </th>
      <td mat-cell *matCellDef="let element"> {{element.prixDzd| currency: ' '}} </td>
    </ng-container>
    <ng-container matColumnDef="prixEuro">
      <th mat-header-cell *matHeaderCellDef style="width: 100px">Prix Euro </th>
      <td mat-cell *matCellDef="let element"> {{element.prixEuro| currency: ' '}} </td>
    </ng-container>

    <ng-container matColumnDef="prixDol">
      <th mat-header-cell *matHeaderCellDef style="width: 100px">Prix Dollar </th>
      <td mat-cell *matCellDef="let element"> {{element.prixDol| currency: ' '}} </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </mat-table>

</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-raised-button color='primary' (click)="save()" cdkFocusInitial>Save</button>


</div>